export default __webpack_public_path__ + "static/5-ed540942281b2b2841d75bd3e7ad3a55.png";